/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EquipmentAvailabilityType {
    WeeklyService = 0,
    MinorService = 1,
    MajorService = 2,
    Unserviceable = 3,
}
